import React, { useContext } from 'react';
var PreviewContext = {
    appId: 'www.wix.com',
    isPreview: false,
};
export var PreviewMode = React.createContext(PreviewContext);
// tslint:disable-next-line: react-hooks-nesting
export var previewModeContext = function () { return useContext(PreviewMode); };
//# sourceMappingURL=preview-context.js.map